import React from 'react'
import Svg from '../../../../packages/uikit/src/components/Svg/Svg'
import { SvgProps } from '../../../../packages/uikit/src/components/Svg/types'

const Icon: React.FC<SvgProps> = (props) => (
  <Svg width="22" height="16" viewBox="0 0 22 16" fill="none" {...props}>
    <g clipPath="url(#clip0_40_24819)">
      <path
        d="M14.5152 11.0988C13.6353 11.6082 12.8303 11.4546 12.0805 10.8135C11.3643 10.0267 10.7736 9.15208 10.391 8.14581C10.2808 7.85741 10.0666 7.71164 9.83242 7.5455C8.91269 6.89189 8.66172 5.39816 9.30446 4.4734C9.433 4.28844 9.44372 4.09252 9.46973 3.88562C9.80794 1.1944 10.9174 0.4107 13.2956 0.0439287C15.5635 -0.305601 17.3494 1.4734 17.4366 3.86054C17.4427 4.03766 17.3678 4.27434 17.5361 4.37308C18.1528 4.73202 18.1345 5.31195 18.0227 5.87778C17.8865 6.57371 17.6463 7.24926 16.9989 7.63327C16.8061 7.74769 16.6944 7.86681 16.6148 8.07371C16.1619 9.26023 15.4594 10.2681 14.5137 11.0988H14.5152Z"
        fill="black"
      />
      <path
        d="M10.6909 11.4513C12.1325 13.1974 14.2963 13.3745 15.9093 11.8337C16.3011 11.4591 16.6485 11.3855 17.1397 11.5344C18.1864 11.851 19.2531 12.1033 20.3014 12.4152C21.6281 12.8118 22.3428 14.3604 21.8363 15.6676C21.7169 15.9764 21.4797 15.9952 21.215 15.9952C16.0455 15.9952 10.8761 15.992 5.70661 15.9983C5.37912 15.9983 5.14192 15.8917 5.09448 15.5532C4.88941 14.1174 4.9644 12.9356 6.59267 12.4387C7.14971 12.2695 7.6991 12.0751 8.25308 11.8933C9.08864 11.8776 9.83697 11.3572 10.6909 11.4482V11.4513Z"
        fill="black"
      />
      <path
        d="M5.73261 6.49371H4.35837V5.08619C4.35837 4.5235 3.91305 4.06738 3.36366 4.06738C2.81427 4.06738 2.36895 4.5235 2.36895 5.08619V6.49371H0.994713C0.445326 6.49371 0 6.94983 0 7.51252C0 8.07522 0.445326 8.53133 0.994713 8.53133H2.36895V9.93886C2.36895 10.5016 2.81427 10.9577 3.36366 10.9577C3.91305 10.9577 4.35837 10.5016 4.35837 9.93886V8.53133H5.73261C6.282 8.53133 6.72732 8.07522 6.72732 7.51252C6.72732 6.94983 6.282 6.49371 5.73261 6.49371Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_40_24819">
        <rect width="22" height="16" fill="white" />
      </clipPath>
    </defs>
  </Svg>
)

export default Icon
